export class FetchTimeEntriesAction {
  static readonly type = '[Project] Fetch Time Entries';

  constructor() {}
}
